import React from "react";
import { Link } from "react-router-dom";
import "../assets/Css/profile.css";
import { picon1, picon2, picon3, picon4, profileimg } from "../Constant/Index";

function Sidebar() {
  return (
    <>
      {/* Side bar section */}
      <div className="siderbar-tabs">
        <div className="sidebar-img">
          <img src={profileimg} className="img-fluid" alt="profile-image" />
          <h3>John Samual</h3>
          <h5>@John Samual</h5>
        </div>
        <ul className="sidebar-ul">
          <li className="border-bottom">
            <Link to="/my-profile">
              <span className="icon-span">
                <img src={picon1} className="img-fluid" alt="icon" />
              </span>{" "}
              My Profile
            </Link>
          </li>
          <li className="border-bottom">
            <Link to="/my-orders">
              <span className="icon-span">
                <img src={picon3} className="img-fluid" alt="icon" />
              </span>
              My Orders
            </Link>
          </li>
          <li className="border-bottom">
            <Link to="/my-address">
              {" "}
              <span className="icon-span">
                <img src={picon2} className="img-fluid" alt="icon" />
              </span>
              My Addresses
            </Link>
          </li>
          

          <li>
            <Link to="/login">
              <span className="icon-span">
                <img src={picon4} className="img-fluid" alt="icon" />
              </span>
              Logout
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
